class UploadTestCaseDataController {
    constructor(Upload, toastr, SettingsService, UserDetailsApi) {
        // Used because $onChanges can fire before $onInit
        this.isInitialized = false;
        this.$onChanges = (changes) => {
            // Make sure we're initialized
            this.$onInit();
            if (changes.suiteId) {
                this.suiteId = changes.suiteId.currentValue;
            }
        };
        this.$onInit = () => {
            if (!this.isInitialized) {
                this.state = {
                    uploadProgress: -1,
                    selectedTest: {},
                    maxUploadMb: 0,
                    errorMsg: '',
                    showError: false,
                    userDetails: {}
                };
                this.SettingsService.getCachedSettings().then((response) => {
                    this.state.maxUploadMb = response.MaxUploadMb;
                });
                this.UserDetails.get().then((response) => {
                    let userData = response.data;
                    this.state.userDetails = userData;
                });
                this.isInitialized = true;
            }
        };
        /////////////////// File Upload Methods ///////////////////
        // Hook method to catch file upload browser dialog
        this.uploadTestCase = (files) => {
            // reset error message
            this.state.showError = false;
            this.state.errorMsg = '';
            // Ensure there is one file selected
            if (files != null) {
                let fac = this.checkFileSizes(files);
                this.uploadFiles(fac.validFiles);
            }
            else {
                this.state.showError = true;
                this.state.errorMsg =
                    'Could not determine file uploaded!\nPlease select a file and try again!';
            }
        };
        // Upload file method to process file and send to WebApi
        this.uploadFiles = (files) => {
            // files = files;
            if (angular.isUndefined(files)) {
                return;
            }
            // Test length should be 1
            if (files.length === 1) {
                let requestDto = {
                    // Get first file as only allowing one upload at a time
                    Files: files[0]
                };
                // Test for User TestSuites (not Sim TestSuites)
                if (this.checkFileExtension(files[0])) {
                    // Upload file to the WebApi
                    this.uploadFileToWebApi(requestDto, this.suiteId);
                }
                else {
                    this.state.showError = true;
                    this.state.errorMsg =
                        "Please select files with extension 'xlsx' only!";
                    this.toastr.error(this.state.errorMsg);
                }
                files = null;
            }
        };
        // Upload File to the Web Api method
        this.uploadFileToWebApi = (requestDto, testSuiteId) => {
            // Upload file to the WebApi
            this.Upload.upload({
                method: 'POST',
                url: 'api/UtpTest/ImportTestCaseInstructions?testSuiteId=' +
                    testSuiteId +
                    '&userId=' +
                    this.state.userDetails.Id,
                data: requestDto,
                headers: {
                    'Content-Type': 'application/x-www-form-urlencoded;charset=utf-8'
                }
            }).then((response) => {
                // success
                this.state.uploadProgress = -1;
                this.onUploaded({ response: response });
            }, 
            // error
            (response) => {
                this.state.uploadProgress = -1;
                this.onUploadError({ response: response });
            }, 
            // progress
            (evt) => {
                this.onProgressUpdate({ evt: evt });
            });
        };
        // Test File size to ensure we do not allow users to upload files too big
        this.checkFileSizes = (files) => {
            let fac = {
                tooLarge: [],
                validFiles: []
            };
            angular.forEach(files, (file) => {
                // Only files < maxUpload Mb
                if (file.size <= 1024 * 1024 * this.state.maxUploadMb) {
                    // 1024*1024 = 1MB in bytes
                    fac.validFiles.push(file);
                }
                else {
                    fac.tooLarge.push(file);
                    this.state.showError = true;
                    this.state.errorMsg =
                        'File is too large. Please select a file less than ' +
                            this.state.maxUploadMb +
                            'MB.';
                    this.toastr.error('File is too large. Please select a file less than ' +
                        this.state.maxUploadMb +
                        'MB.');
                }
            });
            return fac;
        };
        // checkFileExtension is a valid extension
        this.checkFileExtension = (file) => {
            const extentions = 'xlsx';
            if (extentions.indexOf(file.name
                .split('.')
                .pop()
                .toLowerCase()) > -1) {
                return true;
            }
            else {
                return false;
            }
        };
        this.Upload = Upload;
        this.toastr = toastr;
        this.UserDetails = UserDetailsApi;
        this.SettingsService = SettingsService;
    }
}
angular.module('app').component('uploadTestCaseData', {
    bindings: {
        onUploaded: '&',
        onProgressUpdate: '&',
        onUploadError: '&',
        suiteId: '<'
    },
    templateUrl: 'scripts/app/partials/ManageTestSuites/TestCases/upload-test-case-data.tpl.html',
    controllerAs: 'vm',
    controller: UploadTestCaseDataController
});
